export default "__VITE_ASSET__BHaXf9og__"